import { GET_CURRENT_USER, GET_CURRENT_USER_SUCCESS } from 'store/constants/action-types';

export const getCurrentUserAction = () => {
  return { type: GET_CURRENT_USER };
};

export const setCurrentUserAction = (payload) => {
  return { type: GET_CURRENT_USER_SUCCESS, payload: payload };
};
